// const Joi = require('joi').extend(require('@joi/date'))

import Joi from 'joi'
import dayjs from 'dayjs'

const getDaysInMonth = (month, year) => {
  return dayjs(`${year}-${String(month).padStart(2, '0')}-01`).daysInMonth()
}

export const cantDiasTrabajadosValidation = (periodo) => {
  const [year, month] = periodo.split('-').map((part) => parseInt(part, 10))
  const diasEnMes = getDaysInMonth(month, year)

  // Crear esquema dinámico
  return Joi.number()
    .integer()
    .min(1)
    .max(diasEnMes)
    .allow(null, '')
    .messages({
      'number.base': 'La cantidad de días debe ser un número válido',
      'number.integer': 'La cantidad de días debe ser un número entero',
      'number.min': 'La cantidad de días debe ser al menos 1',
      'number.max': `La cantidad de días no puede superar los ${diasEnMes} días del período ${periodo}`,
    })
}

export const nombreValidation = () => {
  return Joi.string().max(60).default('ALTA').allow(null, '').messages({
    'string.max': 'El nombre no debe superar los 60 caracteres',
  })
}

export const cuilValidation = () => {
  return Joi.custom(validarCuil, 'validador CUIL').required().messages({
    'any.required': 'El CUIL es obligatorio',
    'cuil.invalidLength': 'CUIL debe tener 11 dígitos numéricos',
    'cuil.invalidChecksum': 'CUIL no es válido',
  })
}

export const validarCuil = (value, helpers) => {
  // elimina guiones
  // const cuil = value.replace(/-/g, '')
  const cuil = String(value).includes('-') ? value.replace(/-/g, '') : String(value)

  if (!/^\d{11}$/.test(cuil)) {
    return helpers.error('cuil.invalidLength')
  }

  // Algoritmo de validación de CUIL
  const coef = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
  const nums = cuil.split('').map(Number)
  const suma = coef.reduce((acc, v, i) => acc + v * nums[i], 0)
  const control = (11 - (suma % 11)) % 11

  if (control !== nums[10]) {
    return helpers.error('cuil.invalidChecksum')
  }

  return cuil
}
export const sueldoValidation = () => {
  return Joi.custom((value, helpers) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
      return helpers.error('number.base')
    }

    let cleanedValue = String(value).replace(/\./g, '') // Remove thousands separators (dots)
    cleanedValue = cleanedValue.replace(/,/g, '.') // Replace decimal comma with dot

    const parsedValue = parseFloat(cleanedValue)

    if (isNaN(parsedValue)) {
      return helpers.error('number.base')
    }

    if (parsedValue < 0) {
      return helpers.error('number.greater')
    }

    // Check for up to two decimal places
    const decimalPart = cleanedValue.split('.')[1]
    if (decimalPart && decimalPart.length > 2) {
      return helpers.error('number.twoDecimalPlaces')
    }

    return parsedValue
  }, 'validación de sueldo con formato numérico y 2 decimales')
    .required()
    .messages({
      'any.required': 'El sueldo es obligatorio',
      'number.base': 'El sueldo debe ser numérico',
      'number.greater': 'El sueldo debe ser mayor o igual a 0',
      'number.twoDecimalPlaces': 'El sueldo solo puede tener hasta 2 decimales',
    })
}

export const sueldoValidationAux = () => {
  return Joi.alternatives()
    .try(
      Joi.number()
        .greater(0)
        .custom((value, helpers) => {
          // Verificar hasta 2 decimales

          if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
            return helpers.error('number.twoDecimalPlaces')
          }
          return value
        }, 'validación de sueldo con 2 decimales'),
      Joi.string().custom((value, helpers) => {
        // Reemplaza coma por punto, intenta convertir a número
        const num = parseFloat(value.replace(',', '.'))

        if (isNaN(num)) return helpers.error('number.base')
        if (num <= 0) return helpers.error('number.greater')

        if (!/^\d+(\.\d{1,2})?$/.test(num.toString())) return helpers.error('number.twoDecimalPlaces')

        return num
      }, 'validación de sueldo string con coma')
    )
    .required()
    .messages({
      'any.required': 'El sueldo es obligatorio',
      'number.base': 'El sueldo debe ser numérico',
      'number.greater': 'El sueldo debe ser mayor que 0',
      'number.twoDecimalPlaces': 'El sueldo solo puede tener hasta 2 decimales',
    })
}

export const sexoValidation = () => {
  return Joi.string().valid('X', 'M', 'F').allow(null, '').messages({
    'any.only': "El sexo debe ser 'M', 'F' o 'X'",
    'string.base': 'El sexo debe ser un texto válido',
  })
}

export const documentoValidation = () => {
  return Joi.alternatives()
    .try(
      Joi.number().integer().min(1000000).max(99999999).messages({
        'number.base': 'El documento debe ser un número válido',
        'number.min': 'El documento debe ser mayor o igual a 1.000.000',
        'number.max': 'El documento debe ser menor o igual a 99.999.999',
      }),
      Joi.string()
        .pattern(/^[\d.]+$/)
        .custom((value, helpers) => {
          // eliminar puntos y validar rango
          const num = parseInt(value.replace(/\./g, ''), 10)
          if (isNaN(num)) return helpers.error('documento.invalidFormat')
          if (num < 1000000 || num > 99999999) return helpers.error('documento.outOfRange')
          return value
        })
        .messages({
          // 'string.pattern.base': 'El documento solo debe contener números y puntos',
          'string.pattern.base': 'El documento solo debe contener números',
          'documento.invalidFormat': 'El formato del documento no es válido',
          'documento.outOfRange': 'El documento debe estar entre 1.000.000 y 99.999.999',
        })
    )
    .allow(null, '')
    .messages({
      'alternatives.match': 'El documento debe ser un número válido entre 1.000.000 y 99.999.999',
    })
}

export const tipoDocValidation = () => {
  return Joi.number().integer().min(1).max(5).allow(null, '').messages({
    'number.base': 'Tipo de documento debe ser un número válido',
    'number.integer': 'Tipo de documento debe ser un número entero',
    'number.min': 'Tipo de documento inválido (debe estar entre 1 y 5)',
    'number.max': 'Tipo de documento inválido (debe estar entre 1 y 5)',
  })
}

export const fechaNacimientoValidation = () => {
  return Joi.any()
    .allow(null, '')
    .custom((value, helpers) => {
      if (typeof value !== 'string') {
        return helpers.error('fechaNacimiento.notString')
      }

      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        return helpers.error('fechaNacimiento.badFormat')
      }

      const [dia, mes, anio] = value.split('/').map(Number)
      const fecha = new Date(anio, mes - 1, dia)
      if (fecha.getFullYear() !== anio || fecha.getMonth() !== mes - 1 || fecha.getDate() !== dia) {
        return helpers.error('fechaNacimiento.invalid')
      }

      const hoy = new Date()
      let edad = hoy.getFullYear() - anio
      if (hoy < new Date(anio + edad, mes - 1, dia)) edad--
      if (edad < 16 || edad > 90) {
        return helpers.error('fechaNacimiento.outOfRange')
      }

      return value
    })
    .messages({
      'fechaNacimiento.notString': 'La fecha debe ser un texto en formato dd/mm/aaaa',
      'fechaNacimiento.badFormat': 'La fecha debe tener formato dd/mm/aaaa',
      'fechaNacimiento.invalid': 'La fecha ingresada no es válida',
      'fechaNacimiento.outOfRange': 'La edad debe estar entre 16 y 90 años',
    })
}
